module.exports = __webpack_public_path__ + "static/media/checked.7a54f3c5.png";